import { render, staticRenderFns } from "./SearchResultDocumentItem.vue?vue&type=template&id=f7849326&scoped=true&"
import script from "./SearchResultDocumentItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultDocumentItem.vue?vue&type=style&index=0&id=f7849326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7849326",
  null
  
)

export default component.exports